import type { ReactNode } from 'react'
import { Toaster } from 'sonner'

export interface ToastProviderProps {
  children: ReactNode
}

export function ToastProvider({ children }: ToastProviderProps) {
  return (
    <>
      {children}
      <Toaster
        theme="dark"
        position="top-right"
        richColors
        closeButton
        gap={10}
        toastOptions={{
          className: 'font-sans',
        }}
      />
    </>
  )
}